<template>
  <div>


<h2 class="goth"></h2>
<div class="grammatikparagrafbredd leftorient">

    <h4>Prepositioner som styr ackusativ</h4>

    <table class="linjer">


        <tr class="leftorient">
            <td class="vit bggron"><b>durch</b></td>
            <td class="vit bggron">genom</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bggron"><b>für</b></td>
            <td class="vit bggron">för</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bggron"><b>gegen</b></td>
            <td class="vit bggron">mot</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bggron"><b>ohne</b></td>
            <td class="vit bggron">utan</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bggron"><b>um</b></td>
            <td class="vit bggron">runt, omkring, om</td>
        </tr>


    </table>


    <h4>Prepositioner som styr dativ</h4>

    <table class="linjer">


        <tr class="leftorient">
            <td class="vit bgrod"><b>aus</b></td>
            <td class="vit bgrod">ur, från, av</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>außer</b></td>
            <td class="vit bgrod">utom, förutom</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>bei</b></td>
            <td class="vit bgrod">vid, hos</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>gegenüber</b></td>
            <td class="vit bgrod">mittemot, gentemot</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>mit</b></td>
            <td class="vit bgrod">med</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>nach</b></td>
            <td class="vit bgrod">efter, till, enligt</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>seit</b></td>
            <td class="vit bgrod">sedan, alltsedan</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>von</b></td>
            <td class="vit bgrod">från, av, om</td>
        </tr>

        <tr class="leftorient">
            <td class="vit bgrod"><b>zu</b></td>
            <td class="vit bgrod">zu</td>
        </tr>


    </table>


<h4>Prepositioner som styr ackusativ eller dativ</h4>


<table class="linjer">


    <tr class="leftorient">
        <td class="vit bgbrun"><b>an</b></td>
        <td class="vit bgbrun">på <div class="minitext">(vertikalt)</div>  <b> •|</b>, vid</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>auf</b></td>
        <td class="vit bgbrun">på <div class="minitext">(horisontellt)     </div>
             &nbsp; <div style="display:inline-block;"><div style="transform: rotate(90deg);"><b>•|</b></div></div>  </td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>hinter</b></td>
        <td class="vit bgbrun">bakom</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>in</b></td>
        <td class="vit bgbrun">i</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>neben</b></td>
        <td class="vit bgbrun">bredvid, nära</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>über</b></td>
        <td class="vit bgbrun">över, ovanför</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>unter</b></td>
        <td class="vit bgbrun">under</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>vor</b></td>
        <td class="vit bgbrun">framför</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>zwischen</b></td>
        <td class="vit bgbrun">mellan</td>
    </tr>


</table>
<br>

<p class="inlajn">Vid riktning används ackusativ (<b>RiA</b>)
    och vid befintlighet används dativ (<b>BeDa</b>)</p>


<br><br>


<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i ackusativ och dativ</h4><br>

<table class="linjer">

    <tr class="leftorient">
        <td></td>
        <td>mask.</td>
        <td>neutr.</td>
        <td>fem.</td>
        <td>plur.</td>
    </tr>

    <tr class="leftorient">
        <td>nom.</td>
        <td class="vit bgbla">der</td>
        <td class="vit bgbla">das</td>
        <td class="vit bgbla">die</td>
        <td class="vit bgbla">die</td>
    </tr>

    <tr class="leftorient">
        <td>ack.</td>
        <td class="vit bggron"><b>den</b></td>
        <td class="vit bggron">das</td>
        <td class="vit bggron">die</td>
        <td class="vit bggron">die</td>
    </tr>

    <tr class="leftorient">
        <td>dat.</td>
        <td class="vit bgrod"><b>dem</b></td>
        <td class="vit bgrod"><b>dem</b></td>
        <td class="vit bgrod"><b>der</b></td>
        <td class="vit bgrod"><b>den ..n</b> </td>
    </tr>


</table>



<p>Oftast skrivs preposition och artikel ihop till ett ord i följande fall:<br>


<nobr><i>bei+dem=<b>beim</b></i></nobr>
&nbsp;&nbsp;<nobr><i>von+dem=<b>vom</b></i></nobr>
&nbsp;&nbsp;<nobr><i>zu+dem=<b>zum</b></i></nobr>
&nbsp;&nbsp;<nobr><i>zu+der=<b>zur</b></i></nobr>

<br><br>

<nobr><i>an+das=<b>ans</b></i></nobr>
&nbsp;&nbsp;<nobr><i>in+das=<b>ins</b></i></nobr>
&nbsp;&nbsp;<nobr><i>an+dem=<b>am</b></i></nobr>
&nbsp;&nbsp;<nobr><i>in+dem=<b>im</b></i></nobr>
</p>




<br>
    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i ackusativ och dativ</h4><br>


    <table class="linjer">

        <tr class="leftorient">
            <td></td>
            <td>mask.</td>
            <td>neutr.</td>
            <td>fem.</td>

        </tr>

        <tr class="leftorient">
            <td>nom.</td>
            <td class="vit bgbla">ein</td>
            <td class="vit bgbla">ein</td>
            <td class="vit bgbla">eine</td>
        </tr>

        <tr class="leftorient">
            <td>ack.</td>
            <td class="vit bggron"><b>einen</b></td>
            <td class="vit bggron">ein</td>
            <td class="vit bggron">eine</td>
        </tr>
        <tr class="leftorient">
            <td>dat.</td>
            <td class="vit bgrod"><b>einem</b></td>
            <td class="vit bgrod"><b>einem</b></td>
            <td class="vit bgrod"><b>einer</b></td>
        </tr>

    </table>

<br>


<br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i ackusativ och dativ</h4><br>
<table class="linjer">

    <tr class="leftorient">
        <td>svenska</td>
        <td>nominativ</td>
        <td>ackusativ</td>
        <td>dativ</td>
    </tr>

    <tr class="leftorient">
        <td>jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bggron"><b>mich</b></td>
                <td class="vit bgrod"><b>mir</b></td>
    </tr>

    <tr class="leftorient">
        <td>du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bggron"><b>dich</b></td>
                <td class="vit bgrod"><b>dir</b></td>
    </tr>

    <tr class="leftorient">
        <td>han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bggron"><b>ihn</b><br>es<br>sie</td>
                <td class="vit bgrod"><b>ihm</b> <br> <b>ihm</b> <br> <b>ihr</b></td>
    </tr>

    <tr class="leftorient">
        <td>vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bggron"><b>uns</b></td>
                <td class="vit bgrod"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td>ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bggron"><b>euch</b></td>
                <td class="vit bgrod"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td>de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bggron">sie<br>Sie</td>
                <td class="vit bgrod"><b>ihnen<br>Ihnen</b></td>
    </tr>

</table>

<br>


</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
